import { motion } from "framer-motion";
import { ExperienceButton } from "./CTA";

export const Nav = () => (
  <motion.header
    initial={{ y: -64, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
    data-testid="site-nav"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
        <img src="/logo.png" alt="Rest Recovery Wellness North PHX logo" className="h-9 w-auto" />
        <span className="hidden font-display text-sm font-black uppercase tracking-tight sm:block">
          REST Recovery <span className="text-zinc-500">Wellness</span>
        </span>
      </a>
      <div className="hidden md:block">
        <ExperienceButton id="nav-cta-claim" className="px-5 py-2.5" />
      </div>
    </div>
  </motion.header>
);
